import { database } from '@breakroom-nx/apis';
import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { SerializedError } from '@reduxjs/toolkit';

import {
  ref,
  query,
  orderByChild,
  get,
  startAt,
  endAt,
} from 'firebase/database';

const apiName = '[SEARCH API]';
export const searchAPI = createApi({
  reducerPath: 'searchApi',
  keepUnusedDataFor: 3600,
  baseQuery: fakeBaseQuery(),
  tagTypes: ['Users'],
  endpoints: (builder) => ({
    // Get Users based on Username
    getUsersForUsername: builder.query<
      { username: string; uid: string }[],
      string
    >({
      async queryFn(username) {
        try {
          if (!username) {
            return {
              error: { message: 'No username provided' } as SerializedError,
            };
          }

          // console.info(`${apiName}: Getting users for username ${username}`);

          const users: { username: string; uid: string }[] = [];
          const usernamesRef = ref(database, 'usernames');
          const queryConstraints = [
            orderByChild('username'),
            startAt(username),
            endAt(username + '\uf8ff'),
          ];

          await get(query(usernamesRef, ...queryConstraints))
            .then((snap) => {
              if (snap.exists()) {
                snap.forEach((dataSnapshot) => {
                  if (dataSnapshot.exists()) {
                    const data = dataSnapshot.val();
                    const retrievedUsername: string = data.username;
                    const uid: string = data.uid;

                    users.push({ username: retrievedUsername, uid: uid });
                  }
                });
              }
            })
            .catch((err) => {
              throw new Error(err);
            });

          if (users.length === 0) {
            // Return an error if no users are found
            return { error: { message: 'No Users Found' } as SerializedError };
          }

          return { data: users };
        } catch (err) {
          // console.log(`${apiName} Error getting usernames: ${err}`);
          return {
            error: { message: 'Error getting usernames' } as SerializedError,
          };
        }
      },
      providesTags: ['Users'],
    }),
  }),
});

export const { useLazyGetUsersForUsernameQuery } = searchAPI;
